export const ConsumerAutoSubmissionStyles = {
  container: 'flex flex-1 flex-col justify-center content-center mx-2',
  paragraph: 'mt-8 text-black'
}
